import Model from '@/lib/data/Model';

class NaicsPrediction extends Model {
    static idProperty = 'id';

    fields = ['accuracy', 'code', 'title'];

    constructor(data) {
        super(data);
        this.init();
    }
}

export default NaicsPrediction;
